import classnames from 'classnames';
import React from 'react';
import styles from "./Card.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const Card = ({
  children,
  className,
  shadow = true,
  ...rest
}) => {
  const classes = classnames(styles.card, {
    [styles.shadow]: shadow
  }, className);
  return /*#__PURE__*/_jsx("div", {
    className: classes,
    ...rest,
    children: children
  });
};